import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import { French } from 'flatpickr/dist/l10n/fr';
import { German } from 'flatpickr/dist/l10n/de';
import { english } from 'flatpickr/dist/l10n/default';
import { Italian } from 'flatpickr/dist/l10n/it';
import './flatpickr.scss';
// import './overrides.scss';
import flatpickr from './flatpickr';


export default function initDatepicker(el) {
  const overrides = {
    firstDayOfWeek: 1,
  };

  const locales = {
    en: { ...english, ...overrides },
    de: { ...German, ...overrides },
    fr: { ...French, ...overrides },
    it: { ...Italian, ...overrides },
  };
  const { lang } = DOCUMENT_ELEMENT;

  const picker = flatpickr(el, {
    mode: 'range',
    minRange: 2,
    disableStart: 0,
    minDate: 'today',
    altInput: true,
    altFormat: 'j F, Y',
    dateFormat: 'Y-m-d',
    defaultDate: ['today', new Date().fp_incr(1)],
    static: true,
    locale: locales[lang],
  });

  return picker;
}



// WEBPACK FOOTER //
// ./scripts/lib/datepicker/initDatepicker.js